import { Controller } from "@hotwired/stimulus"

const PRESERVE_PARAMS = [
  "start_date", "end_date",
  "attendant_filter", "category_filter", "group_filter", "role_filter"
]

export default class extends Controller {
  static targets = ["ticketsList"]
  static values  = { baseUrl: String }

  setTarget(event) {
    const ds = event.currentTarget.dataset
    if (!ds.filterType) return
    this.navigate({
      type: ds.filterType,
      id:   ds.filterId,
      key:  ds.filterKey,
      date: ds.filterDate
    })
  }

  clear() {
    this.navigate(null)
  }

  navigate(filter) {
    const url = new URL(this.baseUrlValue, window.location.origin)
    const currentParams = new URL(window.location.href).searchParams

    PRESERVE_PARAMS.forEach(key => {
      if (currentParams.get(key)) url.searchParams.set(key, currentParams.get(key))
    })

    if (filter && filter.type) {
      url.searchParams.set("filter[type]", filter.type)
      if (filter.id   != null && filter.id   !== "") url.searchParams.set("filter[id]",   filter.id)
      if (filter.key  != null && filter.key  !== "") url.searchParams.set("filter[key]",  filter.key)
      if (filter.date != null && filter.date !== "") url.searchParams.set("filter[date]", filter.date)
    }

    Turbo.visit(url.toString())

    setTimeout(() => {
      const list = document.getElementById("results-tickets-list")
      if (list) list.scrollIntoView({ behavior: "smooth", block: "start" })
    }, 200)
  }
}
